function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1143.38 19.55l-69.78 40.87L2113.11 660.5 3152.62 60.42l-69.78-40.87-969.73 559.95-969.73-559.95z",
  fill: "#ccc"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1074.06 59.53l-.66 200.61 70.19 40.11-.62-159.79 900.4 519.74-.04 1559.82 70.28 40-.04-1600.23L1074.06 59.53z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3152.17 59.53L2112.66 659.79l-.05 1600.23 70.29-40-.05-1559.82 900.4-519.74-.62 159.79 70.2-40.11-.66-200.61zM1142.73 139.75v160.5l70.14-40v-80.5l-70.14-40z",
  fill: "#999"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3083.5 139.75l-70.15 40v80.5l70.15 40v-160.5z",
  fill: "#787878"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1073.66 259.55L311.33 699.77 727.47 940.5l415.85-240.03 103.88 60.02 242.57-140.03 34.45 20.04 34.44-20.04 207.56 119.42-277 159.76 69.82 40.82 415.95-240.69-762.33-440.22-69.5 39.95-69.5-39.95z",
  fill: "#f45805"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M3013.57 259.55l-762.18 440.04 69.79 40.86 762.17-440.04-69.78-40.86z",
  fill: "#e6cd2e"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M3152.34 259.5l-831.79 480.21L2667.4 940.5l415.67-240 415.69 240 416.14-240.73-762.56-440.27z",
  fill: "#fbe555"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1489.49 619.51l-381.42 220.26 208.38 120.72 381.41-220.26-208.37-120.72zm-34.18 60.16l34.12-19.19 103.69 59.85-34.12 19.19-103.69-59.85zm-35.16 20.81l103.69 59.85-34.13 19.19-103.69-59.85 34.13-19.19zm-69.31 39.99l138.39 79.89-34.13 19.17-138.39-79.89 34.13-19.17zm-34.04 99.28l34.11-19.26 68.95 39.76-34.11 19.26-68.95-39.76zm-104.52-19.28l138.38 79.89-34.13 19.17-138.38-79.89 34.13-19.17z",
  fill: "#ccc"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1559.04 619.54l-35.16 20.84 173.06 99.48-242.31 139.74 35.15 20.86 277.41-160.34-208.15-120.58z",
  fill: "#b03d03"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1489.71 659.52l-35.16 20.81 104.17 60.15 35.16-20.8-104.17-60.16z",
  fill: "#2a1a5e"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M311.34 699.75v960.5l831.82 480.25.43-480.75-415.69-240v-480l-416.56-240z",
  fill: "#ff7f3b"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1420.43 699.52l-35.16 20.81 104.16 60.15 35.16-20.8-104.16-60.16z",
  fill: "#2a1a5e"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1974.98 699.75l-416.56 240v480l-415.69 240 .43 480.75 831.82-480.25v-960.5z",
  fill: "#bf4300"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M2251.25 699.75v960.5l831.82 480.25.49-480.57-70.26-40.07.23 279.71-241.8-139.82.04-279.9-103.91-59.94-.05-480.16-416.56-240z",
  fill: "#ffed79"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M3914.89 699.75l-416.56 240v480l-415.7 240 .44 480.75 831.82-480.25v-960.5z",
  fill: "#e6cd2e"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M1351.17 739.53l-35.15 20.83 138.75 80.11 35.15-20.83-138.75-80.11zM1212.61 819.53l-35.16 20.83 138.75 80.11 35.16-20.83-138.75-80.11zM1351.1 819.51l-35.17 20.74 69.63 40.24 35.16-20.74-69.62-40.24z",
  fill: "#2a1a5e"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M1108.61 839.51l-.44 80.85 208.1 120.13.44-80.85-208.1-120.13z",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1454.84 879.51l-138.85 80.16.47 80.82 208.13-120.16-69.75-40.82z",
  fill: "#787878"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M2840.72 1279.52l-69.8 40.81 208.09 120.15 69.8-40.81-208.09-120.15z",
  fill: "#ccc"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M2770.88 1319.73l-.05 440.44 208.73 120.1.05-440.44-208.73-120.1zm35.38 99.89l-.46-39.14 138.38 79.9.46 39.14-138.38-79.9zm-.32 40.88l68.9 39.83.38 39.17-68.91-39.83-.37-39.17zm-.1 79.99l103.68 59.87.44 39.15-103.68-59.87-.44-39.15zm104.45 19.26l-.18-39.32 33.96 19.82.18 39.32-33.96-19.82zm-104.49 60.73l138.38 79.9.46 39.14-138.38-79.9-.46-39.14zm.14 80.02l68.9 39.83.38 39.17-68.91-39.83-.37-39.17zm104.35 99.25l-.18-39.32 33.96 19.82.18 39.32-33.96-19.82z",
  fill: "#fff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M2806.08 1379.52l-.47 40.86 138.75 80.1.47-40.86-138.75-80.1z",
  fill: "#38237f"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M3048.9 1399.84l-70.23 40v160.32l70.23 40.01v-240.33z",
  fill: "#787878"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M2805.94 1459.5l-.38 40.83 69.66 40.17.38-40.82-69.66-40.18zM2909.61 1519.57l-.18 40.68 35.32 20.18.19-40.68-35.33-20.18zM2806.03 1539.51l-.44 40.85 104.18 60.13.44-40.85-104.18-60.13z",
  fill: "#38237f"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M2978.65 1599.93v280.13l35.63 20.01v-280.13l-35.63-20.01z",
  fill: "#b8aa57"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M2806.08 1619.52l-.47 40.86 138.75 80.1.47-40.86-138.75-80.1zM2805.94 1699.5l-.38 40.83 69.66 40.17.38-40.82-69.66-40.18zM2909.61 1759.57l-.18 40.68 35.32 20.18.19-40.68-35.33-20.18z",
  fill: "#38237f"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M2043.83 1979.5l-416.19 240.57 485.47 280.43 485.48-280.43-416.19-240.57-.49 240.38-68.8 39.62-68.79-39.62-.49-240.38z",
  fill: "#ccc"
});

var _ref28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M2113.11 379.5L1904.77 500l208.34 120.5L2321.46 500l-208.35-120.5z",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1905.02 499.57l-.21 240.63 138.69 80.18-.05 39.95 70.14 39.81-.03-280.37-208.54-120.2z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2321.21 499.57l-208.54 120.2-.04 280.37 70.14-39.81-.05-39.95 138.7-80.18-.21-240.63z",
  fill: "#999"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2320.71 499.57v40.86L2356.1 520l-35.39-20.43z",
  fill: "#787878"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2459.36 659.53l-138.75 80.11 35.15 20.83 138.76-80.11-35.16-20.83z",
  fill: "#e6cd2e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2320.71 739.57v40.86L2356.1 760l-35.39-20.43z",
  fill: "#ffed79"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1628.33 2219.54l-.49 80.86 485.08 280.06.49-80.86-485.08-280.06z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2597.9 2219.54l-485.08 280.06.48 80.86 485.09-280.06-.49-80.86z",
  fill: "#999"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#787878",
  d: "M2286.32 480l1.84-3.19 17.32 10-1.84 3.19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#787878",
  d: "M2303.64 490l1.84-3.19 17.32 10-1.84 3.19zM2320.96 500h3.69v20h-3.69zM2320.96 520h3.69v20h-3.69z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M2061.15 830l-1.84 3.19-17.32-10 1.84-3.19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M2078.47 840l-1.84 3.19-17.32-10 1.84-3.19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#787878",
  d: "M2165.08 830l1.84 3.19-17.32 10-1.85-3.19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#787878",
  d: "M2182.4 820l1.84 3.19-17.32 10-1.84-3.19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M2095.79 850l-1.84 3.19-17.32-10 1.84-3.19zM2113.11 860v4.26l-19.16-11.07 1.84-3.19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#787878",
  d: "M2130.43 850l1.85 3.19-19.17 11.07V860z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#787878",
  d: "M2147.75 840l1.85 3.19-17.32 10-1.85-3.19z"
})));

function SvgCubes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4157 2720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubes);
export default __webpack_public_path__ + "static/media/cubes.af7b863a.svg";
export { ForwardRef as ReactComponent };